<template>
</template>
<script>
export default {
  data() {
    let vm = this;
    return {
      element: null,
      resources: {
        width: {
          name: 'width',
          defaultValue: '300',
          min: '150',
          max: '600',
          labelDesc: 'width',
          callback: function() {
            vm.resources.width.defaultValue = this.value;
            vm.element.internal_config.width = this.value + 'px';
          }
        },
        colorReadMore: {
          name: 'backgroundColor',
          defaultValue: '#ffffff',
          gradient: false,
          labelDesc: 'color-hover',
          callback: function() {
            vm.resources.colorReadMore.defaultValue = this.colorValue;
            vm.element.internal_config.colorReadMore = this.colorValue;
          }
        },
        subTextStyle: {
          name: 'blogTitleStyle',
          defaultFamily: '',
          defaultSize: '',
          defaultColor: '',
          defaultSizeMobile: '',
          shitOptions: true,
          showSizeMobile: true,
          defaultStroke: '',
          defaultAlign: '',
          labelDesc: 'blogTitleStyle',
          callback: function() {
            vm.resources.subTextStyle.defaultFamily = this.family;
            vm.element.internal_config.titleStyle.family = this.family;

            vm.resources.subTextStyle.defaultSize = this.size + 'px';
            vm.element.internal_config.titleStyle.size = this.size + 'px';

            vm.resources.subTextStyle.defaultSizeMobile = this.sizeMobile + 'px';
            vm.element.internal_config.titleStyle.sizeMobile = this.sizeMobile + 'px';

            vm.resources.subTextStyle.defaultColor = this.color;
            vm.element.internal_config.titleStyle.color = this.color;

            vm.resources.subTextStyle.defaultAlign = this.align;
            vm.element.internal_config.titleStyle.align = this.align;

            vm.resources.subTextStyle.defaultWeight = this.weight;
            vm.element.internal_config.titleStyle.weight = this.weight;

            vm.resources.subTextStyle.defaultStyle = this.style;
            vm.element.internal_config.titleStyle.style = this.style;

            vm.resources.subTextStyle.defaultStroke = this.stroke;
            vm.element.internal_config.titleStyle.stroke = this.stroke;
          }
        },
        zIndex: {
          name: 'zIndex',
          defaultValue: '',
          labelDesc: 'zIndex',
          callback: function() {
            vm.resources.zIndex.defaultValue = this.value;
            vm.element.internal_config.zIndex = this.value;
          }
        }
        // text: {
        // 	name: 'label',
        // 	defaultValue: '',
        // 	labelDesc: 'search-label-text',
        // 	canRemove: false,
        // 	max: 20,
        // 	callback: function () {
        // 		vm.resources.text.defaultValue = this.value;
        // 		vm.element.internal_config.lbltext = this.value;
        // 	},
        // },
        // textBtn: {
        // 	name: 'blogBtnText',
        // 	defaultValue: '',
        // 	labelDesc: 'search-label-btn',
        // 	canRemove: false,
        // 	max: 20,
        // 	callback: function () {
        // 		vm.resources.textBtn.defaultValue = this.value;
        // 		vm.element.internal_config.btnText = this.value;
        // 	},
        // },

      }
    };
  },
  methods: {
    setMinValuesData(resource, value) {
      this.resources[resource].min = parseInt(value);
    },
    setValuesData(data) {
      this.element = data;

      this.resources.colorReadMore.defaultValue = data.internal_config.colorReadMore;
      this.resources.subTextStyle.defaultFamily = data.internal_config.titleStyle.family;
      this.resources.subTextStyle.defaultSize = data.internal_config.titleStyle.size;
      this.resources.subTextStyle.defaultSizeMobile = data.internal_config.titleStyle.sizeMobile;
      this.resources.subTextStyle.defaultColor = data.internal_config.titleStyle.color;
      this.resources.subTextStyle.defaultAlign = data.internal_config.titleStyle.align;
      this.resources.subTextStyle.defaultWeight = data.internal_config.titleStyle.weight;
      this.resources.subTextStyle.defaultStyle = data.internal_config.titleStyle.style;
      this.resources.subTextStyle.defaultStroke = data.internal_config.titleStyle.stroke;

      this.resources.width.defaultValue = data.internal_config.width;

      this.resources.width.defaultValue = data.internal_config.width;

      this.resources.zIndex.defaultValue = data.internal_config.zIndex;

      // this.resources.text.defaultValue =  data.internal_config.lbltext;
      // this.resources.textBtn.defaultValue =  data.internal_config.btnText;
    },
    getValuesData() {
      return this.resources;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Blog/Categories/Resources.vue